/* pages/Gate.jsx — signed in, but Docs Protocol isn't open to this account yet. */

import { api } from '../lib/api.js';
import { session, store, forgetSession, loadSession } from '../state.js';
import { Button, confirmDialog } from '../ui/ui.jsx';
import { ProtoCard } from '../ui/proto.jsx';

/** Sign out, and wipe this device's copy of the docs, unless that would lose unsynced work. */
export async function signOut() {
  const s = store.value;
  if (s) {
    const pending = await s.pendingDocs().catch(() => []);
    if (pending.length) {
      const sure = await confirmDialog({
        title: 'Some changes haven\'t synced yet',
        text: `${pending.length === 1 ? 'One doc has' : `${pending.length} docs have`} changes that are only on this device so far. If you sign out now, they stay here until you sign back in on this device. Sign out anyway?`,
        ok: 'Sign out anyway', danger: true,
      });
      if (!sure) return;
    }
    await api('/api/auth/logout', { method: 'POST' }).catch(() => {});
    if (!pending.length) await s.destroy().catch(() => {});
  } else {
    await api('/api/auth/logout', { method: 'POST' }).catch(() => {});
  }
  forgetSession();
  store.value = null;
  await loadSession();
  history.replaceState(null, '', '/');
}

export function Gate() {
  const s = session.value;
  return (
    <div class="center-page">
      <ProtoCard title="Not open yet"
        text={`Hi! Docs Protocol is still being tested, so only a few accounts can use it right now. ${s.user?.email} isn't one of them yet, but it'll open to everyone soon. I'm sharpening my pencils.`}
        actions={<>
          <Button onClick={signOut}>Sign out</Button>
          <a class="btn primary" href="https://weatherprotocol.org">Go to Weather Protocol</a>
        </>} />
    </div>
  );
}
